import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (path, { method = "GET", body } = {}) => {
      const res = await fetch(`${API}${path}`, {
        method,
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${await getToken()}` },
        body: body ? JSON.stringify(body) : undefined,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const err = new Error(data.detail || `Request failed (${res.status})`);
        err.status = res.status;
        throw err;
      }
      return data;
    },
    [getToken]
  );
}

export function useResource(path) {
  const call = useApi();
  const [state, setState] = useState({ data: null, error: null, loading: true });
  const reload = useCallback(() => {
    call(path)
      .then((data) => setState({ data, error: null, loading: false }))
      .catch((error) => setState({ data: null, error, loading: false }));
  }, [call, path]);
  useEffect(() => { reload(); }, [reload]);
  return { ...state, reload };
}
